import { BitbucketOrgUnit } from './use-bxp-web-stargate-client.types';

/**
 * Map an Atlassian GraphQL gateway `admin_unitsForOrg` response to the flat unit list
 * the Bitbucket unit picker needs (COMMIT-29289). Tolerant of missing/partial data:
 * unknown shapes and nodes without an id+name are dropped, yielding [] in the worst case.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mapBitbucketOrgUnits(graphqlJson: any): BitbucketOrgUnit[] {
	const edges = graphqlJson?.data?.admin_unitsForOrg?.edges ?? [];
	if (!Array.isArray(edges)) {
		return [];
	}
	return (
		edges
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			.map((edge: any) => edge?.node)
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			.filter((node: any) => node?.id && node?.name)
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			.map((node: any) => ({
				// AdminUnit.id is an ARI ("ari:cloud:platform::collaboration-context/<id>"), but
				// BXP's collabContextId — and the signup server's TCS cc-links lookup — expect the
				// bare resource id, so strip the ARI prefix. Bare ids pass through unchanged.
				// (COMMIT-29289: a full ARI produced a doubled ARI server-side → 500.)
				id: String(node.id).split('/').pop() as string,
				name: String(node.name),
			}))
	);
}

/**
 * True only when the org's units-eligibility (gateway `admin_unitSettings`) is
 * `UNITS_ACTIVATED` — the one state in which platform surfaces like WAC should surface Units
 * (all orgs have units under the hood; see ccp1/6607628184 + COMMIT-29289). Any other state,
 * missing data, or error → false (fail closed / picker hidden).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isUnitsActivatedResponse(graphqlJson: any): boolean {
	return graphqlJson?.data?.admin_unitSettings?.unitsEligibilityState === 'UNITS_ACTIVATED';
}
